module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/claim-process-fedbdaa4467abbd0acb4ce6ca45aef29.png";